<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>

    export default {
        name: "App",
        data() {
            return {}
        },
        mounted() {
            this.setColor();
        },
        methods: {
            setColor() {
                let that = this;
                let color = that.$store.state.rootColor;
                let color_opt = that.$store.state.rootOptColor;
                let root = document.querySelector(":root");
                if (color) root.style.setProperty("--color", color);
                if (color_opt) root.style.setProperty("--color_opt", color_opt);
            }
        },
    }
</script>

<style lang="scss">
    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        height: 100%;
    }
</style>
